import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiNotifications = (config) => {
    return useQuery({
        queryKey: ['user', 'notification', 'get', config],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/notifications`, config)
        })({params: config})),
    })
}


export const useApiSeenNotifications = () => {
    return useMutation({
        mutationFn: (uuid) =>
            ((async (uuid = {}) => {
                return generalRequest.put(`/notification/${uuid.uuid}`)
            })(uuid))
    });
}


export const useApiRejectNotifications = () => {
    return useMutation({
        mutationFn: (uuid) =>
            ((async (uuid = {}) => {
                return generalRequest.delete(`/notification/${uuid.uuid}`)
            })(uuid))
    });
}


export const useApiAcceptNotifications = () => {
    return useMutation({
        mutationFn: (uuid) =>
            ((async (uuid = {}) => {
                return generalRequest.post(`/notification/${uuid.uuid}`)
            })(uuid))
    });
}


